import { mdiHelpCircle, mdiHelpCircleOutline } from '@mdi/js';
import { Icon } from '@mdi/react';
import { styled } from 'styled-components';
import { trackEvent } from 'lib/amplitude';

const VARIANTS = {
  dark: {
    color: '#92a6be',
    hoverColor: '#fff',
    hoverBackground: '#8f99a826',
    borderRadius: 0,
  },
  light: {
    color: '#252f70',
    hoverColor: '#252f70',
    hoverBackground: '#edf1f9',
    borderRadius: '100%',
  },
};

const AnchorButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  color: ${({ $variant }) => VARIANTS[$variant].color};
  border-radius: ${({ $variant }) => VARIANTS[$variant].borderRadius};

  &:hover {
    color: ${({ $variant }) => VARIANTS[$variant].hoverColor};
    background: ${({ $variant }) => VARIANTS[$variant].hoverBackground};
    cursor: pointer;
  }
`;

const IconHelp = styled(Icon).attrs(({ $variant }) => ({
  path: $variant === 'light' ? mdiHelpCircleOutline : mdiHelpCircle,
}))`
  width: 18px;
  height: 18px;
  color: inherit;
  alt: 'help';
`;

/**
 * HelpLink component
 *
 * @param {object} props - props object
 * @param {string} props.url - URL to the help documentation
 * @param {string} props.dashboardId - ID of the dashboard
 * @param {string} props.dashboardName - Name of the dashboard
 * @param {string} props.variant - color variant for the help link
 *
 * @returns {JSX.Element} HelpLink component
 */
export default function HelpLink({
  url = 'https://docs.urbanfootprint.com/private/analyst',
  dashboardId,
  dashboardName,
  variant = 'dark',
}) {
  const handleClick = () => {
    trackEvent('Help Link Clicked', { url, dashboardId, dashboardName });
  };
  return (
    <AnchorButton
      aria-label="External Help Link"
      onClick={handleClick}
      target="_blank"
      rel="noreferrer noopener"
      href={url}
      $variant={variant}
    >
      <IconHelp $variant={variant} />
    </AnchorButton>
  );
}
